module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.contents), function(content) {
    return _c('div', [_c('img', {
      attrs: {
        "src": content.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    }), _vm._v(" "), (_vm.input.isActive) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputVal),
        expression: "inputVal"
      }],
      attrs: {
        "type": "text",
        "name": "input",
        "placeholder": _vm.input.placeholder
      },
      domProps: {
        "value": (_vm.inputVal)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.onSubmit($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.inputVal = $event.target.value
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.secondInput.isActive) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.secondInputVal),
        expression: "secondInputVal"
      }],
      attrs: {
        "type": "text",
        "name": "input",
        "placeholder": _vm.secondInput.placeholder
      },
      domProps: {
        "value": (_vm.secondInputVal)
      },
      on: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.onSubmit($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.secondInputVal = $event.target.value
        }
      }
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "button-caption"
    }, [(option.type != 'done' && option.isOption && !_vm.input.isActive && !option.isHttpRequest) ? _c('router-link', {
      class: {
        'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue',
      },
      attrs: {
        "to": {
          name: 'Option',
          params: {
            id: option.id
          }
        }
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.type != 'done' && !option.isOption && !_vm.input.isActive && !option.isHttpRequest) ? _c('router-link', {
      class: {
        'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue',
      },
      attrs: {
        "to": {
          name: 'Question',
          params: {
            id: option.id
          }
        }
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.input.isActive) ? _c('a', {
      class: {
        'yes': option.type == 'yes',
          'no': option.type == 'no',
          'continue': option.type == 'continue',
      },
      on: {
        "click": _vm.onSubmit
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.isHttpRequest) ? _c('a', {
      class: {
        'yes': option.type == 'yes',
          'no': option.type == 'no',
          'continue': option.type == 'continue',
      },
      on: {
        "click": option.onClick
      }
    }, [(option.type == 'continue') ? _c('span', [_vm._v("DEVAM ET")]) : _vm._e(), _vm._v(" "), (option.type == 'yes') ? _c('span', [_vm._v("EVET")]) : _vm._e(), _vm._v(" "), (option.type == 'no') ? _c('span', [_vm._v("HAYIR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option.type === 'done') ? _c('router-link', {
      staticClass: "continue",
      attrs: {
        "to": {
          name: 'Success'
        }
      }
    }, [_c('span', [_vm._v("BİTİR")])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('router-link', {
    staticClass: "not-these",
    attrs: {
      "to": {
        name: 'Contact',
        query: {
          gim: '1'
        }
      }
    }
  }, [_vm._v("\n      Bunların Dışında\n      "), _c('span', {
    staticClass: "go-icon"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e0279a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = 229
// module chunks = 1